/** @prettier */

/**
 * プライバシーポリシー
 */

import {useEffect, useState} from 'react';

import {Container, Box, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';

//Style import
import '../../css/common/common.css';

import {Link} from 'react-router-dom';

import {file} from '../../define';
import {
  getPublicS3Files,
  createDisplayDataFromFileNames,
  createDownloadLink,
  createURLDate,
  languageInfo,
  PublicFileList,
} from './helpFunction';

const PrivacyPolicy = (props: {isAuthenticated: boolean}) => {
  const trans = useTranslation().t; //翻訳関数

  const [fileData, setFileData] = useState({
    current: {
      fileNameList: {}, // 現行のプライバシーポリシーのファイル名
      fileDateList: {}, // 現行のプライバシーポリシーが適応された日
    },
    nextScheduled: {
      fileNameList: {}, // 次に適用されるプライバシーポリシーのファイル名
      fileDateList: {}, // 次に適用されるプライバシーポリシーの予定日
    },
    isReady: false, // プライバシーポリシーの表示の可否
  });

  useEffect(() => {
    //S3からファイル情報を取得して表示用のデータを生成する
    const fetchData = async () => {
      //S3の公開バケットからファイル情報一覧を取得
      const fileList = await getPublicS3Files(
        file.PUBLIC_DOCUMENT_S3_KEY_PREFIX
      );

      //ファイル情報一覧からファイル名だけ取得
      const filesNameList = fileList.flatMap(file => {
        return file.key ? [file.key] : [];
      });

      //ファイル名から各言語の表示データを作成
      const result = createDisplayDataFromFileNames(
        filesNameList,
        'privacy-policy'
      );

      setFileData({
        ...result,
        isReady: true,
      });
    };

    fetchData();
  }, [trans]);

  /**
   * URLクリック時の処理
   * @param fileList - ファイル情報
   */
  const handleURLClick = (fileList: string) => {
    return createDownloadLink(
      fileList,
      trans('privacyPolicy.message.errorText.downloadError')
    );
  };

  /**
   * ダウンロードリンクを描画する関数
   * @param fileData - 現行または次に適用されるファイルの情報 (ファイル名リストと日付リストを含む)
   * @param title - タイトル
   */
  const RenderFileLinks = (fileData: PublicFileList, title: string) => {
    const availableLanguages = languageInfo.filter(lang => {
      return fileData.fileNameList[lang];
    });

    return (
      <Box>
        <h3>{title}</h3>
        <Box component="ul" className="help__body--privacyPolicy__link">
          {availableLanguages.map(lang => {
            //言語名称
            const fileLanguage = trans(
              `privacyPolicy.message.url.languages.${lang}`
            );
            //固定文
            const linkText = trans('privacyPolicy.message.url.text');
            //日付情報
            const fileDateInfo = createURLDate(
              fileData.fileDateList[lang],
              trans
            );

            return (
              <Box component="li" key={lang}>
                <Link
                  to="#"
                  onClick={() => handleURLClick(fileData.fileNameList[lang])}>
                  {`${fileLanguage} (${linkText} ${fileDateInfo})`}
                </Link>
              </Box>
            );
          })}
        </Box>
      </Box>
    );
  };

  /**
   * プライバシーポリシーの表示コンポーネント
   * @returns プライバシーポリシー表示コンポーネントのJSX要素
   */
  const PrivacyPolicySection = () => {
    const isCurrentFileNotExit = Object.values(
      fileData.current.fileNameList
    ).every(fileInfo => fileInfo === '');

    const isNextScheduledFileExit = Object.values(
      fileData.nextScheduled.fileNameList
    ).some(fileInfo => fileInfo !== '');

    //ファイル情報が１言語も存在しない場合はエラーメッセージを表示する
    if (isCurrentFileNotExit) {
      return (
        <Box component="p">
          <span>{trans('privacyPolicy.message.errorText.error')}</span>
        </Box>
      );
    }

    return (
      <>
        {/* 現在のファイルのURLを表示 */}
        {RenderFileLinks(
          fileData.current,
          trans('privacyPolicy.message.text.currentFile')
        )}

        {/*次に適用予定のファイルのURLを表示 */}
        {/*更新予定のファイルが存在しない場合項目自体を表示しない*/}
        {isNextScheduledFileExit &&
          RenderFileLinks(
            fileData.nextScheduled,
            trans('privacyPolicy.message.text.earliestFile')
          )}
      </>
    );
  };

  return (
    <>
      <Container fixed>
        <Stack spacing={5}>
          {/**タイトル */}
          <Box className="help__title">
            <h1> {trans('privacyPolicy.title')}</h1>
          </Box>
          <h2 className="help__body__subtitle">
            {trans('privacyPolicy.subtitle')}
          </h2>
          {/** 英文が正であることの説明 */}
          <Box className="help__body__instruction">
            {trans('privacyPolicy.message.englishOriginalInstruction')}
          </Box>
          {/**プライバシーポリシ－ */}
          <Box className="help__body help__body--privacyPolicy">
            {fileData.isReady && <PrivacyPolicySection />}
          </Box>
        </Stack>
      </Container>
      {/** ログイン前専用フッター */}
      {props.isAuthenticated ? (
        <></>
      ) : (
        <footer>
          <Box component="span" className="text">
            © Mitsubishi Heavy Industries Thermal Systems, Ltd.
          </Box>
        </footer>
      )}
    </>
  );
};
export default PrivacyPolicy;
